/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Settings_Save_SuccessInputs */



/**
* | output |
* | --- |
* | "Uno settings updated." |
*
* @param {Uno_Settings_Save_SuccessInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_settings_save_success = /** @type {((inputs?: Uno_Settings_Save_SuccessInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Settings_Save_SuccessInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Uno-Einstellungen aktualisiert.")
	return /** @type {LocalizedString} */ ("Uno settings updated.")
});